import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Overlay } from 'react-overlays';
import scrollParent from '../../services/scroll-parent';
import withTranslate from '../../hoc/with-translate';
import styles from './text-editor-button.scss';
import Tooltip from './tooltip';

export class TextEditorButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    icon: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onKeyUp: PropTypes.func,
    children: PropTypes.node,
    tooltipText: PropTypes.string,
    t: PropTypes.func,
    theme: PropTypes.object,
  };

  state = {
    isTooltipVisible: false,
  };

  componentWillUnmount() {
    this.handleMouseLeave();
  }

  handleMouseDown = event => {
    const { isDisabled, onClick } = this.props;

    event.preventDefault();
    this.handleMouseLeave();
    if (onClick && !isDisabled) {
      onClick();
    }
  };

  handleMouseEnter = () => {
    this.timeout = setTimeout(() => {
      this.setState({
        isTooltipVisible: true,
      });
    }, 500);
  };

  handleMouseLeave = () => {
    clearTimeout(this.timeout);
    this.setState({
      isTooltipVisible: false,
    });
  };

  render() {
    const {
      className,
      isActive,
      isDisabled,
      onKeyUp: handleKeyUp,
      children,
      tooltipText,
      icon: Icon,
      t,
      theme,
    } = this.props;
    const isHighlighted = isActive && !isDisabled;
    const containerClassName = classNames(styles.button, className, 'text-editor-button', {
      [styles.isHighlighted]: isHighlighted,
    });
    const iconClassName = classNames(styles.icon, {
      [get(theme, 'icon.normal')]: !isHighlighted,
      [get(theme, 'icon.highlighted')]: isHighlighted,
    });
    const iconHoverClassName = classNames(styles.icon, styles.iconHover, get(theme, 'icon.hover'));

    return (
      <div
        className={containerClassName}
        onKeyUp={handleKeyUp}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        disabled={isDisabled}
        aria-label={t(tooltipText)}
        tabIndex="0"
      >
        <Icon className={iconClassName}/>
        <Icon className={iconHoverClassName}/>
        {children}
        <Overlay
          show={this.state.isTooltipVisible}
          placement="top"
          container={scrollParent()}
          target={this}
          onHide={this.handleMouseLeave}
          rootClose
        >
          <Tooltip theme={get(theme, 'tooltip')}>
            {t(tooltipText)}
          </Tooltip>
        </Overlay>
      </div>
    );
  }
}

export default withTranslate(TextEditorButton);



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-button.js